import { put, call, take, fork } from 'redux-saga/effects'
import { CourseCreationSuggestSectionTitleService } from '../../api/course-creation'
import { aICreatorSuggestSectionTitleSuccess } from '../../reducers/ai-creator/action'
import { SUGGEST_SECTION_TITLE } from '../../reducers/ai-creator/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 * Flow for suggesting section titles
 * @param {Object} payload - The payload containing requestData and callback
 */
function* suggestSectionTitleFlow(payload) {
  try {
    const { requestData, callback } = payload

    const response = yield call(
      CourseCreationSuggestSectionTitleService,
      requestData,
    )

    yield put(aICreatorSuggestSectionTitleSuccess(response))
    yield put(operationSuccess())

    if (callback) {
      callback(response)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 * Watcher for suggest section title actions
 */
export default function* aICreatorSuggestSectionTitleWatcher() {
  while (true) {
    const action = yield take(SUGGEST_SECTION_TITLE)
    const { payload } = action

    yield fork(generalSaga, suggestSectionTitleFlow, payload, false)
  }
}
